import './ItemProgressBar.css';

/**
 * Thin gradient progress bar — matches the left sidebar campaign item style.
 */
export default function ItemProgressBar({ progress = 0, complete = false, className = '' }) {
  const clamped = Math.min(100, Math.max(0, Math.round(progress)));

  return (
    <div
      className={[
        'item-progress-bar',
        complete && 'item-progress-bar--complete',
        className,
      ].filter(Boolean).join(' ')}
      style={{
        '--progress': `${clamped}%`,
        '--progress-num': clamped || 1,
      }}
    />
  );
}
